import { role } from "@/helpers/role";
import { object } from "yup";
import {Menu, SubMenu} from "@/core/config/LayoutMainMenuConfig";
import store from "@/store";
import ApiService from '../../core/services/ApiService';

 const currentUser = store.getters.currentUser;

 const isAdmin =store.getters.isAdmin;
 const pCode = currentUser.partnerCode;
 const use2Sonline = isAdmin?true:currentUser.use2Sonline;
//console.log("use2SOnline",currentUser);

export const getUserMenu =(prefix = "") =>  [
  {
    name: "partnerMenu",
    roles: [role.owner, role.manager, role.user],
    pages: [
      {
        sectionTitle: "รายการขาย",
        route: prefix + "/order",

        svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-basket",
        sub: [
          {
            heading: "ใบเสนอราคา",
            route: prefix + "/order/sellrequest",
            
          },
          {
            heading: "ดูใบเสนอราคา",
            route: prefix + "/order/sellrequestlist",
            
          },
          {
            heading: "ค้างส่ง(ใบเสนอราคา)",
            route: prefix + "/order/nondeliveryreport",
            //roles: [role.user],
            
          }, 
          {
            heading: "เปิดบิล",
            route: prefix + "/order/create",
          },
          {
            heading: "ดูบิลขาย",
            route: prefix + "/order",
          }, 
          // {...(use2Sonline?{
          //   heading: "คำสั่งซื้อ 2SOnline",
          //   route: prefix + "/order2slist"
          //   }:{})
          // },               
          // {
          //   heading: "ดูรายการใบรับมัดจำ",
          //   route: prefix + "/order/aivoucherlist",
          // },          
          {
            heading: "การขายตามสินค้า",
            route: prefix + "/order/product-sales-summary",
          },
          {
            heading: "การขายตามหมวด",
            route: prefix + "/order/product-sellorder",
          },
        ],
      },
      {...(use2Sonline?{
          sectionTitle: "คำสั่งซื้อ 2SOnline",
          route: prefix + "/order2s",
          svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
          fontIcon: "bi-basket",
          sub: [
            {
              heading: "ค้างส่ง",
              route: prefix + "/order2s"
            },
            {
              heading: "รอยืนยันส่ง",
              route: prefix + "/order2s/shipment2slist/nondelivery"
            },
            {
              heading: "สำเร็จ",
              route: prefix + "/order2s/shipment2slist/success"
            },
            {
              heading: "ใบวางบิลค่าขนส่ง",
              route: prefix + "/order2s/billingnote",
            }
            // {...((isAdmin || pCode == 'J0142')?
            //   {
            //     heading: "ใบวางบิลค่าขนส่ง",
            //     route: prefix + "/order2s/billingnote",
            //   }:{})
            // },
          ],
        }:{})
      },
      {
        sectionTitle: "รายการรับ-คืนสินค้า",
        route: prefix + "/transfer",
        svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
        fontIcon: "bi-truck",
        sub: [
          {
            heading: "รับสินค้า",
            route: prefix + "/transfer/receive",
          },
          {
            heading: "คืนสินค้า",
            route: prefix + "/transfer/return",
          },
        ],
      },
      {
        sectionTitle: "สินค้า",
        route: prefix + "/products",
        svgIcon: "media/icons/duotune/abstract/abs026.svg",
        fontIcon: "bi-box-seam",
        sub: [
          {
            heading: "สต๊อกและราคา",
            route: prefix + "/products/stock",
          },
          {
            heading: "จองย้ายสินค้า",
            route: prefix + "/products/booking",
          },          
        ],
      },
      {
        sectionTitle: "ลูกค้า",
        route: prefix + "/customers",
        svgIcon: "media/icons/duotune/communication/com005.svg",
        fontIcon: "bi-people",
        sub: [
          {
            heading: "ทะเบียนลูกค้า",
            route: prefix + "/customers",
          },
        ],
      },
      {
        sectionTitle: "การเงิน",
        route: prefix + "/financial",
        svgIcon: "media/icons/duotune/finance/fin010.svg",
        fontIcon: "bi-currency-dollar",
        sub: [
          // {
          //   heading: "ภาพรวม",
          //   route: prefix + "/apps/chat/private-chat",
          // },
          {
            heading: "ดูรายการค้างชำระเงิน",
            route: prefix + "/financial/overduereport",
          }
        ],
      },
      {
        sectionTitle: "รายงาน",
        route: prefix + "/reports/",
        svgIcon: "media/icons/duotune/finance/fin010.svg",
        fontIcon: "bi-file-earmark-bar-graph",
        sub: [  
          {
            heading: "สินค้าไม่เคลื่อนไหว",
            route: prefix + "/reports/productnotmove",
          },                
          {
            heading: "สินค้าค้างนาน",
            route: prefix + "/reports/stocklongtime",
          },     
                        
        ],
      },
    ],
  },
  
];
// :(prefix = "") =>  [  
//   {
//     name: "partnerMenu",
//     roles: [role.owner, role.manager, role.user],
//     pages: [
//       {
//         sectionTitle: "รายการขาย",
//         route: prefix + "/order",
//         svgIcon: "media/icons/duotune/ecommerce/ecm001.svg",
//         fontIcon: "bi-basket",
//         sub: [
//           {
//             heading: "เปิดบิล",
//             route: prefix + "/order/create",
//           },
//           {
//             heading: "ดูบิลขาย",
//             route: prefix + "/order",
//           },          
//           // {
//           //   heading: "ดูรายการใบรับมัดจำ",
//           //   route: prefix + "/order/aivoucherlist",
//           // },          
//           {
//             heading: "การขายตามสินค้า",
//             route: prefix + "/order/product-sales-summary",
//           },
//         ],
//       },
//       {
//         sectionTitle: "รายการรับ-คืนสินค้า",
//         route: prefix + "/transfer",
//         svgIcon: "media/icons/duotune/ecommerce/ecm006.svg",
//         fontIcon: "bi-truck",
//         sub: [
//           {
//             heading: "รับสินค้า",
//             route: prefix + "/transfer/receive",
//           },
//           {
//             heading: "คืนสินค้า",
//             route: prefix + "/transfer/return",
//           },
//         ],
//       },
//       {
//         sectionTitle: "สินค้า",
//         route: prefix + "/products",
//         svgIcon: "media/icons/duotune/abstract/abs026.svg",
//         fontIcon: "bi-box-seam",
//         sub: [
//           {
//             heading: "สต๊อกและราคา",
//             route: prefix + "/products/stock",
//           },
//           {
//             heading: "จองย้ายสินค้า",
//             route: prefix + "/products/booking",
//           },          
//         ],
//       },
//       {
//         sectionTitle: "ลูกค้า",
//         route: prefix + "/customers",
//         svgIcon: "media/icons/duotune/communication/com005.svg",
//         fontIcon: "bi-people",
//         sub: [
//           {
//             heading: "ทะเบียนลูกค้า",
//             route: prefix + "/customers",
//           },
//         ],
//       },
//       {
//         sectionTitle: "การเงิน",
//         route: prefix + "/financial",
//         svgIcon: "media/icons/duotune/finance/fin010.svg",
//         fontIcon: "bi-currency-dollar",
//         sub: [
//           // {
//           //   heading: "ภาพรวม",
//           //   route: prefix + "/apps/chat/private-chat",
//           // },
//           {
//             heading: "ดูรายการค้างชำระเงิน",
//             route: prefix + "/financial/overduereport",
//           },
//         ],
//       },
//       {
//         sectionTitle: "รายงาน",
//         route: prefix + "/reports/",
//         svgIcon: "media/icons/duotune/finance/fin010.svg",
//         fontIcon: "bi-file-earmark-bar-graph",
//         sub: [  
//           {
//             heading: "สินค้าไม่เคลื่อนไหว",
//             route: prefix + "/reports/productnotmove",
//           },                
//           {
//             heading: "สินค้าค้างนาน",
//             route: prefix + "/reports/stocklongtime",
//           },              
//         ],
//       },
//     ],
//   },
  
// ];


// const pmenu = (partnerCode) : Array<any>=> {
//   if(userMenu[0] && userMenu[0].pages) {
//     return userMenu[0].pages.map(m1 => Object.assign(m1, { 
//       route: "/partners/" + partnerCode + m1.route, 
//       sub: m1.sub ? m1.sub.map(m2 => Object.assign(m2, {route: "/partners/" + partnerCode + m2.route})) : []
//     }) )
//   }
//   return [];
  
// }

// export const genPartnerViewMenu = (partnerCode) : any => ({
//   sectionTitle: "เมนูพาร์ทเนอร์",
//   route: "/partners/" + partnerCode,
//   // svgIcon: "media/icons/duotune/communication/com005.svg",
//   fontIcon: "bi-list",
//   sub: pmenu(partnerCode),
//   roles: [role.admin],
// })

export const adminMenu : Array<any> = [
  {
    name: "adminMenu",
    pages: [
      {
        sectionTitle: "จัดการสินค้าฝากขาย",
        route: "admin/products/",
        fontIcon: "bi-box-seam",
        sub: [
          {
            heading: "กำหนดสินค้า & ตั้งราคา",
            route: "/admin/products/setproduct",
          },          
          // {
          //   heading: "ตั้งราคาสินค้า",
          //   route: "/admin/setprice",
          // },
        ],
        roles: [role.admin],
      },
      {
        heading: "Campaign",
        route: "/admin/campaign",
        fontIcon: "bi-currency-dollar",
        roles: [role.admin],
      },
      {
        heading: "ข่าวสาร",
        route: "/admin/news",
        fontIcon: "bi bi-newspaper",
        roles: [role.admin],
      },
      {
        sectionTitle: "รายงาน",
        route: "/admin/reports/",
        fontIcon: "bi-file-earmark-bar-graph",
        sub: [
          // {
          //   heading: "ภาพรวม",
          //   route: "/apps/chat/private-chat",
          // },
          {
            heading: "ยอดขาย",
            route: "/admin/reports/orders",
          },
          {
            heading: "การขายตามสินค้า",
            route: "/admin/reports/salereports/product-sales-summary",
          },
          {
            heading: "การขายตามหมวด",
            route: "/admin/reports/sellorderreport/product-sellorder",
          },   
          {
            heading: "สินค้าไม่เคลื่อนไหว",
            route: "/admin/reports/productnotmove/",
          }, 
          {
            heading: "สินค้าค้างนาน",
            route: "/admin/reports/stocklongtime",
          },                          
          {
            heading: "การชำระเงิน",
            route: "/admin/reports/overdue",
          },  
          {
            heading: "ลูกค้า",
            route: "/admin/reports/customer",
          },                    
          {
            heading: "จองย้าย & รับ-คืน สินค้า",
            route: "/admin/reports/transfers",
          },            
        ],
        roles: [role.admin],
      },
    ],
    roles: [role.admin],
  },
  {
    route: "/partners",
    name: "partnerView",
    pages: [
      {
        heading: "จัดการพาร์ทเนอร์",
        route: "/partners",
        // svgIcon: "media/icons/duotune/communication/com005.svg",
        fontIcon: "bi-people",
        // sub: [
        //   {
        //     heading: "ทะเบียนพาร์ทเนอร์",
        //     route: "/admin/partners",
        //   },
        // ],
        roles: [role.admin],
      },     
    ],
    roles: [role.admin],
  },
]

export const getMenu = () => {
  const user = store.getters.currentUser;
  const currentRole = store.getters.currentRole;
  const selectPartnerCode = store.getters.getRepresentId;

  if(user.role == "Admin") {
    return currentRole != "Admin" ? [
      
      ...getUserMenu("/partners/"+ selectPartnerCode) ,
      {
        heading: "จัดการพาร์ทเนอร์",        
        pages: [
          
          {
            fontIcon: "bi-people-fill",
            heading: "เลือกพาร์ทเนอร์",
            route: "/partners"
          },
          {
            fontIcon: "bi-box-arrow-left",
            heading: "ออกจากการจัดการพาร์ทเนอร์",
            route: "/"
          },
        ]
      },
    ]: adminMenu
  } else {
    return getUserMenu()
  }
}

export default [ ...getUserMenu(), ...adminMenu];
